// ---------------------------------------------
// Mobile Facets - DeSight Shopify Theme
// ---------------------------------------------
// Body Class für z-index Fix bei Mobile Facets
// ---------------------------------------------

import { $$ } from '../utils/helpers.js';

export function initMobileFacets() {
  const mobileFacetDisclosures = $$('.mobile-facets__disclosure');

  if (mobileFacetDisclosures.length === 0) return;

  mobileFacetDisclosures.forEach(disclosure => {
    disclosure.addEventListener('toggle', (e) => {
      if (e.target.hasAttribute('open')) {
        document.body.classList.add('menu-opening');
      } else {
        document.body.classList.remove('menu-opening');
      }
    });
  });
}
